import React, { useEffect } from "react";

const LoginHistory = () => {
  useEffect(() => {
    console.log("Login history");
  }, []);
  return <div><x-lang>Login History</x-lang></div>;
};

export default LoginHistory;
